import React, { Component } from "react";
import { hot } from "react-hot-loader";

import Logo from "./components/Logo/Logo";
import { BrowserRouter as Router } from "react-router-dom";
import Layout from "./components/Layout/Layout";
import FormBuilder from "./containers/FormBuilder/FormBuilder";
import classes from "./App.module.scss";
import { APP_ROUTER_BASE_NAME } from "./config";

class App extends Component {
  state = {
    start: [],
  };

  render() {
    return (
      <div className={classes.TicketfinderApp}>
        <Logo />
        <div className={classes.container}>
          <Router basename={APP_ROUTER_BASE_NAME}>
            <Layout>
              <FormBuilder />
            </Layout>
          </Router>
        </div>
      </div>
    );
  }
}

export default hot(module)(App);
